import { render, staticRenderFns } from "./TotpForm.vue?vue&type=template&id=5722bec4&"
import script from "./TotpForm.vue?vue&type=script&lang=js&"
export * from "./TotpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports